import React from "react";

const Maintenance = () => {
  return (
    <div className="maintenance-page">
      <div className="maintenance-card">
        <p className="maintenance-eyebrow">MLinc Solutions</p>
        <h1>We&rsquo;re currently performing maintenance</h1>
        <p className="maintenance-text">
          Our site is temporarily unavailable while we make updates and
          improvements.
        </p>
        <p className="maintenance-text">Please check back soon.</p>
      </div>
    </div>
  );
};

export default Maintenance;
